<template>
  <div>
    <el-drawer
      title="新增客户"
      custom-class="add-drawer"
      :visible.sync="drawer"
      :direction="$utils.isMobile() ? 'btt' : 'rtl'"
      :before-close="handleClose"
      :size="$utils.isMobile() ? '80%' : '35rem'"
      :wrapperClosable="false"
    >
      <div class="form-content">
        <el-form :label-position="$utils.isMobile() ? 'top' : 'left'" label-width="100px" :model="form">
          <el-form-item label="学校">
            <el-select
              style="width: 100%"
              v-model="form.schoolIdList"
              multiple
              placeholder="请选择"
              filterable
            >
              <el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品">
            <el-select style="width: 100%" v-model="form.productIdList" multiple placeholder="请选择" @change="handleProductChange">
              <el-option v-for="item in productList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <!-- 每个已选产品对应一个版本选择（可不选） -->
            <div class="version-line" v-for="productId in form.productIdList" :key="productId">
              <span class="version-label">{{ getProductName(productId) }}</span>
              <el-select v-model="versionMap[productId]" placeholder="请选择版本（可不选）" clearable size="small" style="flex: 1">
                <el-option v-for="item in versionOptionMap[productId] || []" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="负责销售" v-if="$store.state.userData.type === 5">
            <el-select v-model="form.userId" filterable placeholder="请选择" style="width: 100%">
              <el-option v-for="item in salePersonOption.slice(1)" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select style="width: 100%" v-model="form.orderType" placeholder="请选择" clearable>
              <el-option v-for="item in orderTypeList.slice(1)" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="到期时间">
            <el-date-picker
              style="width: 100%"
              v-model="form.endDayStr"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-button class="save-btn" @click="save" :loading="loadSave">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
      <drawer-close
        v-if="!$utils.isMobile()"
        :visible="drawer"
        right="35rem"
        @close="handleClose"
      ></drawer-close>
    </el-drawer>
  </div>
</template>
<script>
import { addSchoolProduct, findProductVersionList } from "@/api/customer/index.js";
import { mapState } from "vuex";
export default {
  props: {
    drawer: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      direction: "rtl",
      labelPosition: "top",
      loadSave: false,
      form: {
        schoolIdList: [],
        productIdList: [],
        userId: "",
        endDayStr: "",
        orderType: null,
      },
      versionMap: {}, // 产品id -> 已选版本id
      versionOptionMap: {}, // 产品id -> 版本选项列表
    };
  },
  watch: {
    drawer(val) {
      if (val) {
        this.loadSave = false;
      }
    },
  },
  computed: {
    ...mapState(["productList", "orderTypeList", "schoolList", "salePersonOption"]), // 映射 state.count 到组件中的 computed 属性
  },
  created() {},
  methods: {
    getProductName(productId) {
      let product = this.productList.find((item) => item.id === productId);
      return product ? product.name : "";
    },
    // 产品选择变化，为新选的产品加载版本列表
    handleProductChange(productIdList) {
      productIdList.forEach((productId) => {
        if (!this.versionOptionMap[productId]) {
          findProductVersionList({ productId })
            .then((res) => {
              this.$set(this.versionOptionMap, productId, res.data || []);
            })
            .catch(() => {
              this.$set(this.versionOptionMap, productId, []);
            });
        }
      });
    },
    save() {
      this.loadSave = true;
      // 组装带版本的订购列表
      const schoolProductModelList = this.form.productIdList.map((productId) => ({
        productId,
        versionId: this.versionMap[productId] || null,
      }));
      addSchoolProduct({ ...this.form, schoolProductModelList })
        .then(() => {
          this.$MessageBox.MessageSuccess("新增成功");
          this.$emit('updateList')
          this.handleClose();
        })
        .catch((err) => {
          this.$MessageBox.MessageWarning(err.data.msg);
          this.loadSave = false;
        });
    },
    handleClose() {
      this.form = {
        schoolIdList: [],
        productIdList: [],
        userId: "",
        endDayStr: "",
        orderType: null,
      };
      this.versionMap = {};
      this.loadSave = false;
      this.$emit("update:drawer", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.version-line {
  display: flex;
  align-items: center;
  margin-top: 0.5rem;
  .version-label {
    flex-shrink: 0;
    width: 6rem;
    font-size: 0.8rem;
    color: #606266;
    text-align: left;
  }
}
.save-btn {
  width: 6.9rem;
  height: 2.38rem;
  background: $primary-btn-color;
  border: none;
  color: #fff;
  border-radius: 6px;
  display: inline-block;
  margin: 0.5rem 0 3rem;
  cursor: pointer;
}
</style>